import { Injectable } from '@angular/core'; // Importing from Angular core, adjust if not using Angular
import { first } from 'rxjs/operators';
import { RcContext } from 'app/modules/remote-control-ng/context/rcContext';
import { RestartThrottling } from './restartThrottling';

@Injectable({
    providedIn: 'root'
})
export class RCTransferService {
    constructor(private restartThrottling: RestartThrottling) { }

    public completeTransfer() {
        const id = RcContext.instance.sotiAssistDeviceId;

        const multiScreenUI = RcContext.instance.multiScreen;
        if (multiScreenUI) {
            let monitorId = multiScreenUI.requestMonitorId;
            const monitors = multiScreenUI.monitorList;
            if (!monitors || monitors.length < 2) {
                monitorId = -1;
            }
            else if (monitorId > 0) {
                const monitor = monitors.find((m) => m.id === monitorId);
                if (monitor) {
                    multiScreenUI.requestMonitorId = monitorId;
                    multiScreenUI.updateMonitorInfo(monitor, false);
                } else {
                    monitorId = -1;
                }
            }
            if (monitorId > -1) {
                this.restartThrottling.send(100, true, RcContext.instance)
            }
        }

        const deviceContextHandler = RcContext.instance.deviceContextHandler;
        deviceContextHandler?.contextReady$
            .pipe(first(isReady => isReady === true)) // receives only the first message and automatically unsubscribe once received
            .subscribe(() => RcContext.instance.deviceScreenTransformService?.updateAfterTransfer());
    }
}
